import "../../../styles/input.scss";

import React, {Component} from "react";

import {Link} from "react-router-dom";
import PropTypes from "prop-types";
import {withRouter} from "react-router-dom";

export class TitleTabs extends Component {
    constructor(props){
        super(props);
    }

    render() {
        return(
            <div className="titletabs">
                {this.props.children}
            </div>
        );
    }
}
TitleTabs.propTypes = {
    children: PropTypes.node.isRequired,
};

class TitleTabClass extends Component {
    render() {
        const {
            deviceType,
            url,
            urlTest,
            label,
            onClick
        } = this.props;
        const path =  this.props.location.pathname;
        const isTinyDevice = deviceType=="xs" || deviceType=="sm" || deviceType == "md";
        return onClick ? (
            <div className={`titletabs-item ${path.startsWith(urlTest || url,0) ? "active" : ""} ${isTinyDevice ? "titletabs-tiny-padding" : "titletabs-large-padding"}`} onClick={onClick}>
                {label}
            </div>
        ) : (
            <Link className={`titletabs-item ${path.startsWith(urlTest || url,0) ? "active" : ""} ${isTinyDevice ? "titletabs-tiny-padding" : "titletabs-large-padding"}`} to={url}>
                {label}
            </Link>
        );
    }
}
TitleTabClass.propTypes = {
    deviceType: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    urlTest: PropTypes.string,
    location: PropTypes.object,
    onClick: PropTypes.func,
};

export const TitleTab = withRouter(TitleTabClass);